import { Link } from "react-router-dom";
import { Info, ArrowRight } from "lucide-react";
import Footer from "@/components/Footer";

/**
 * Programma referral chiuso.
 * I vecchi link /invita/:code non devono tornare 404 né creare nuovi
 * referral: mostriamo un semplice avviso e un invito alla registrazione
 * normale.
 */
export default function ReferralCapture() {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--bg-1)] text-[var(--fg-1)]" data-testid="referral-closed-page">
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-lg w-full text-center">
          <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] font-sans font-semibold text-[#00F2F4]">
            <Info size={12} /> Programma concluso
          </div>
          <h1 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight">
            Il programma referral di RecenUp è stato chiuso
          </h1>
          <p className="mt-5 text-sm md:text-base text-[var(--fg-3)] leading-relaxed">
            Grazie per il tuo interesse. Al momento non è più possibile iscriversi tramite link di invito, ma puoi registrarti al servizio in modo normale e provare RecenUp per 14 giorni senza carta di credito.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              data-testid="referral-closed-signup"
              className="inline-flex items-center gap-2 rounded-full bg-[#00F2F4] hover:bg-[#00D6D8] text-[#0A0A0A] px-6 py-3 text-sm font-sans font-semibold"
              style={{ transition: "background-color 0.2s ease" }}
            >
              Registrati gratis <ArrowRight size={14} />
            </Link>
            <Link
              to="/pricing"
              data-testid="referral-closed-pricing"
              className="inline-flex items-center gap-2 rounded-full border border-[var(--border-c)] hover:border-[var(--fg-2)] text-[var(--fg-1)] px-6 py-3 text-sm font-sans"
              style={{ transition: "border-color 0.2s ease" }}
            >
              Vedi i piani
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
